import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: "122px",
    width: "100%",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    top: "0",
    zIndex: "999",
  },
  loginBtn: {
    paddingRight: "13rem",
    [theme.breakpoints.down(1093)]: {
      paddingRight: 0,
    },
  },
  paadingleft: {
    paddingLeft: 0,
    [theme.breakpoints.down(1093)]: {
      paddingLeft: 0,
    },
  },
  primarytext:{
    color: `${theme.agentTheme.background.primary_text} !important`
  },
  contentText: {
    fontWeight: 700,
    fontSize: "14px",
    color: theme.agentTheme.card.link_foreground,
    whiteSpace: "nowrap",
    textDecoration: "none",
    marginRight: "50px",
    cursor: "pointer",
    zIndex: "5",
    paddingLeft: "8px",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      marginRight: "22px",
    },
  },
  dropdownText: {
    fontWeight: 400,
    fontSize: "14px",
    color: theme.agentTheme.card.link_foreground,
    height: "36px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    zIndex: "5",
    paddingRight: "20px",
    paddingLeft: "8px",
  },
  logoImg: {
    height: "70px",
    width: "auto",
    marginLeft: "30px",
    marginRight: "39px",
    cursor: "pointer",
  },
  menuBox: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "9px",
    height: "505px",
    width: "400px",
  },
  menuLogo: {
    height: "40.3px",
    width: "auto",
  },
}));

export default useStyles;
